import $ from 'jquery';
import stickybits from 'stickybits';
import ReadingPositionIndicator from '../vendor/rpi/rpi.js';


$(document).on('ready', function() {


/* Read progress indicator
********************************************/

if ($('.js-reading-wrapper').length) {
	var rpi;
	setTimeout(function waitUntilDomIsReadyLoadingCustomFontsMightOffsetThis() {
		rpi = new ReadingPositionIndicator({
			rpiArea: '.js-reading-wrapper',
			progressBar: {
				show: true,
			},
			percentage: {
				show: false, // default false
				displayBeforeScroll: false, // default false
			},
		}).init();
	}, 1000);
}



/* Read time indicator
********************************************/

if ($('.js-reading-time').length) {
	$(function () {
		var txt = $(".js-reading-content")[0].textContent,
			wordCount = txt.match(/\S+/g).length,
			wpm = 250,
			readingTimeInMinutes = 1;

		var readingTime = wordCount / wpm;
		var readingTimeModulo = readingTime - Math.floor(readingTime);
		if (wordCount > wpm) {
			if ((readingTimeModulo >= 0) && (readingTimeModulo < 0.8)) {
				readingTimeInMinutes = Math.floor(wordCount / wpm);
			} else {
				readingTimeInMinutes = Math.floor(wordCount / wpm) + 1;
			}
		}

		$('.js-reading-time').html(readingTimeInMinutes);
	});
}


/* Adding class on anchor that contains image
********************************************/

if ($('.c-article').length) {
	$('article p a:has(img), article .wp-caption a:has(img)').addClass('c-article__image-link');
	$('article img').closest('p').addClass('c-article__image-container');
}


/* Sticky sidebar
********************************************/

if ($('.js-sticky-sidebar').length) {
	const stickyHeaderHeight = $( '.site-header .main-nav' ).outerHeight( true );
	const stickyHeaderOffset = stickyHeaderHeight + 19;
	const stickySidebarHeight = $( '.js-sticky-sidebar' ).outerHeight( true );
	const stickySidebarVisibleHeight = $( '.js-sticky-sidebar .js-sticky-sidebar-visible' ).outerHeight( true );
	const stickySidebarOffset = stickyHeaderOffset - (stickySidebarHeight - stickySidebarVisibleHeight);

	$('.js-sticky-sidebar').css('top', stickySidebarOffset);
}


/* Sharing
********************************************/

if ($('.js-social-sharing').length) {
	$('.js-social-sharing .social-likes_expander').on('click', function (e) {
		e.preventDefault();
		$('.js-social-sharing').toggleClass('is-active');
	});
}



});
